<template>
  <div :class="{'tcdc-article-card-border-green': border }">
    <v-row justify="center">
      <v-col>
        <div class="tcdc-ebook-card">
          <span class="tcdc-ebook-card-inside">
            <img :src="image" class="tcdc-ebook-image" />
          </span>
        </div>
        <p class="sub-header1 text-tcdc-green mt-6 bold">{{title}}</p>
        <span
          class="text-tcdc-grey1 bold"
        >
          {{description}}
        </span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span class="text-tcdc-grey1 bold mr-4">{{ date | moment('DD MMM') }}</span>
        <img src="../../assets/icons/generals/download.png" class="tcdc-download-icon mr-2" />
        <span class="text-tcdc-grey1 bold">{{formatNumber(viewer)}}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    date: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: ""
    },
    viewer: {
      type: Number,
      default: null
    }
  },
  methods: {
    formatNumber(num) {
      if (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        if (num == 0) return '0';
        return 'Not available'
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-article-card-border-green {
  border-bottom: 2px solid $tcdcGreen;
}
.tcdc-ebook-card {
  overflow: hidden;
  height: 0;
  padding-top: 100%;
  background-color: $tcdcGrey2;
  position: relative;
  /* display: flex;
  align-items: center;
  justify-content: center; */
}
.tcdc-ebook-card-inside {
  position: absolute;
  width: 80%;
  height: 80%;
  /* max-width: 80%;
  max-height: 80%; */
  top: 50%;
  bottom: 0;
  left: 50%;
  right: 0;
  transform: translate(-50%, -50%);

  background-color: $tcdcGrey2;
  display: flex;
  align-items: center;
  justify-content: center;

  /* margin-left: -20px; */
  /* text-align: center; */
  /* position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto; */
  /* margin-left: auto;
  margin-right: auto; */
  /* width: 100%;
  height: 100%; */
}
.tcdc-ebook-image {
  height: 100%;
  object-fit: contain;
  /* max-width: 100%;
  max-height: 100%; */
}
</style>
